<div class="header-content">
  <mwo-header></mwo-header>
  <div class="spacer"></div>
  <div #sidePanel class="side-panel-container" xmlns="http://www.w3.org/1999/html">

    <!--div *ngIf="offline" class="loading-gif-container">
        <span class="sync-color">{{'Offline'}}</span>
        <span class="loader"></span>
      </div-->

    <div *ngIf="_showMenu" class="floating-menu">
      <input #check type="checkbox">
      <ul class="floating-nav">
        <!--
            TODO :: Remove background-color here, must use a css class.
          -->
        <!-- <button (click)="openHelp()" [ngStyle]="help ? {'background-color': '#FF5353'} : {'background-color': 'white'}"
          [style]="check.checked ? {} : {'box-shadow':'none'}" class="help-ripple round-button" mat-mini-fab>
          <img id="help-button" alt="Help" [src]="help ? 'assets/icons/help-on.svg' : 'assets/icons/help.svg'" />
        </button> -->

        <mwo-button class="first-ripple round-button" [svgIcon]="'mwo-settings'" (onClick)="toggleSettings()"
          [noShadow]="!check.checked" [active]="settings"></mwo-button>


        <!-- [ngClass]="environment.enableDesktopMode ? 'second-ripple round-button' : 'first-ripple round-button'" -->

        <mwo-button class="second-ripple round-button" [svgIcon]="'mwo-help'" [active]=" help"
          [noShadow]="!check.checked" (onClick)="openHelp()"></mwo-button>

        <mwo-button class="third-ripple round-button" *ngIf="!environment.enableDesktopMode" [noShadow]="!check.checked"
          [icon]="'swap_horiz'" (onClick)="toggleSidePanel()"></mwo-button>
        <!-- <button (click)="toggleSettings()" *ngIf="environment.enableDesktopMode"
          [ngStyle]="settings ? {'background-color': '#FF5353'} : {'background-color': 'white'}"
          [style]="check.checked ? {} : {'box-shadow':'none'}" class="settings-ripple first-ripple round-button"
          mat-mini-fab>
          <img alt="Settings" [src]="settings ? 'assets/icons/Settings.svg' : 'assets/icons/Settings-OFF.svg'" />
        </button> -->



        <mwo-button
          *ngIf="!environment.enableDesktopMode"
          class="forth-ripple round-button"
          [noShadow]="!check.checked" [icon]="'exit_to_app'" (onClick)="handleClickLogout()"></mwo-button>


        <!--
        <li *ngIf="!environment.enableDesktopMode" class="blacklist-ripple third-ripple round-button" matRipple>
          <button (click)="openBlacklist()">
            <mat-icon style="color: #707070"></mat-icon>
          </button>
        </li> -->
        <!-- <li *ngIf="!environment.enableDesktopMode" class="exit-ripple forth-ripple round-button" matRipple>
          <button (click)="handleClickLogout()">
            <mat-icon>exit_to_app</mat-icon>
          </button>
        </li> -->


        <mwo-button [icon]="'menu'" class="menu-ripple" (onClick)="checkChanged(check)"
          [active]="check.checked"></mwo-button>

        <!-- TODO :: change iamge here, must be why is not centered-->

        <!-- <button (click)="checkChanged(check)"
          [ngStyle]="check.checked ? {'background-color': '#FF5353'} : {'background-color': 'white', 'z-index': '1'}"
          class="menu-ripple" mat-mini-fab>
          <img alt="Menu" [src]="check.checked ? 'assets/icons/menu-on.svg' : 'assets/icons/menu.svg'" />
        </button> -->
      </ul>
    </div>

    <div *ngIf="!environment.enableDesktopMode" class="side-panel">
      <div class="side-panel">

        <mwo-zone-selection (changePlayer)="onChangePlayer($event)" [isSidePanel]="true" [showMenu]="_showMenu">
        </mwo-zone-selection>
      </div>
    </div>
  </div>
</div>
